import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password-success-dialog',
  templateUrl: './change-password-success-dialog.component.html',
  styleUrls: ['./change-password-success-dialog.component.scss'],
  imports: [MatButton, MatDialogClose, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ChangePasswordSuccessDialogComponent {}
